import { useCallback, useSyncExternalStore } from 'react';

let isOpen = false;
const listeners = new Set<() => void>();

function emit() {
  listeners.forEach((l) => l());
}

export function openGlobalAppHelpFloating() {
  if (!isOpen) {
    isOpen = true;
    emit();
  }
}

export function closeGlobalAppHelpFloating() {
  if (isOpen) {
    isOpen = false;
    emit();
  }
}

export function toggleGlobalAppHelpFloating() {
  isOpen = !isOpen;
  emit();
}

export function useGlobalAppHelpFloating() {
  const open = useSyncExternalStore(
    (onStoreChange) => {
      listeners.add(onStoreChange);
      return () => listeners.delete(onStoreChange);
    },
    () => isOpen,
    () => false,
  );

  return {
    isOpen: open,
    open: useCallback(() => openGlobalAppHelpFloating(), []),
    close: useCallback(() => closeGlobalAppHelpFloating(), []),
    toggle: useCallback(() => toggleGlobalAppHelpFloating(), []),
  };
}
